import { Tournament } from '../../domain/models';
import { TournamentRepository } from '../../domain/repositories';
import { TournamentDataSource } from '../datasources';
import { tournamentEntityToModel, tournamentModelToEntity } from '../entities';

export class TournamentRepositoryImpl implements TournamentRepository {
  constructor(private dataSource: TournamentDataSource) {}

  async create(tournament: Omit<Tournament, 'id' | 'createdAt' | 'updatedAt'>): Promise<Tournament> {
    const entity = tournamentModelToEntity(tournament);
    const createdEntity = await this.dataSource.create(entity as any);
    return tournamentEntityToModel(createdEntity);
  }

  async getById(id: string): Promise<Tournament | null> {
    const entity = await this.dataSource.getById(id);
    if (!entity) return null;
    return tournamentEntityToModel(entity);
  }

  async getAll(limit?: number, offset?: number): Promise<Tournament[]> {
    const entities = await this.dataSource.getAll(limit, offset);
    return entities.map(tournamentEntityToModel);
  }

  async getPublic(limit?: number, offset?: number): Promise<Tournament[]> {
    const entities = await this.dataSource.getPublic(limit, offset);
    return entities.map(tournamentEntityToModel);
  }

  async update(id: string, tournament: Partial<Tournament>): Promise<Tournament> {
    const entity = tournamentModelToEntity(tournament);
    const updatedEntity = await this.dataSource.update(id, entity);
    return tournamentEntityToModel(updatedEntity);
  }

  async delete(id: string): Promise<void> {
    await this.dataSource.delete(id);
  }
}
